var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramCircle = function SvgTelegramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#telegram-circle_svg__b)",
    d: "M12.724 24.019c6.633 0 12.01-5.377 12.01-12.01C24.734 5.377 19.357 0 12.724 0 6.092 0 .714 5.377.714 12.01c0 6.632 5.378 12.009 12.01 12.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.14 11.879a384 384 0 0 1 7.015-3.012c3.33-1.384 4.022-1.627 4.47-1.646.094 0 .318.019.468.131.112.094.15.224.168.318.02.094.038.3.02.468-.188 1.889-.955 6.51-1.366 8.623-.169.898-.505 1.197-.823 1.235-.693.056-1.235-.468-1.908-.898-1.048-.692-1.647-1.122-2.675-1.796-1.179-.785-.412-1.216.261-1.908.169-.187 3.255-2.974 3.311-3.236 0-.037.02-.15-.056-.206-.075-.056-.168-.037-.243-.019-.112.02-1.796 1.142-5.07 3.349-.486.337-.916.486-1.309.486-.43 0-1.253-.243-1.87-.449-.749-.243-1.347-.374-1.291-.785.037-.206.337-.43.898-.655",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram-circle_svg__b",
    x1: 0.715,
    x2: 24.716,
    y1: 12.001,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
};
export { SvgTelegramCircle as ReactComponent };